/* ============================================
   ESTILO DE BOTÓN DE ACCIÓN DESTACADO ("estrella")
   ============================================
   Degradado violeta vivo, brillo que cruza al hover y chispa que late
   en el icono. Es shape-agnostic: NO fija borderRadius ni padding, así
   se puede aplicar por igual a botones alargados, ovalados o redondos
   (Button contained, Fab, etc.) conservando cada uno su forma.

   Se usa como fuente única de verdad tanto en overrides globales del
   tema MUI (index.jsx) como en `sx` puntuales. Por eso solo contiene
   propiedades CSS reales (nada de atajos tipo `px`/`py` de sx).

   Nota de diseño: al hacer hover el botón NO se desplaza verticalmente
   (antes usaba translateY(-3px) y "saltaba"). La sensación de elevación
   se transmite solo con la sombra y el desplazamiento del degradado. */
export const starActionStyles = {
    position: 'relative',
    overflow: 'hidden',
    textTransform: 'none',
    fontWeight: 800,
    letterSpacing: 0.2,
    color: '#fff',
    border: 0,
    background: 'linear-gradient(125deg, #6366f1 0%, #8b5cf6 48%, #d946ef 100%)',
    backgroundSize: '200% 200%',
    backgroundPosition: '0% 50%',
    boxShadow: '0 10px 26px rgba(124, 58, 237, 0.38)',
    transition: 'transform 0.25s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.25s ease, background-position 0.5s ease',
    '@keyframes aiSparkle': {
        '0%, 100%': { transform: 'scale(1) rotate(0deg)' },
        '50%': { transform: 'scale(1.18) rotate(10deg)' }
    },
    // Chispa que late: icono de arranque de Button o cualquier elemento .fab-spark (Fab).
    '& .MuiButton-startIcon svg, & .fab-spark': { animation: 'aiSparkle 2.2s ease-in-out infinite' },
    // Brillo que cruza en diagonal al pasar el ratón.
    '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-75%',
        width: '45%',
        height: '100%',
        background: 'linear-gradient(120deg, transparent, rgba(255,255,255,0.5), transparent)',
        transform: 'skewX(-20deg)',
        transition: 'left 0.6s ease',
        pointerEvents: 'none'
    },
    '&:hover': {
        // Se mantiene el degradado (evita que MUI lo pise con el color sólido del tema).
        background: 'linear-gradient(125deg, #6366f1 0%, #8b5cf6 48%, #d946ef 100%)',
        backgroundSize: '200% 200%',
        // Sin translateY: la elevación la da la sombra, no un salto de posición.
        backgroundPosition: '100% 50%',
        boxShadow: '0 18px 34px rgba(124, 58, 237, 0.48)'
    },
    '&:hover::after': { left: '130%' },
    // El único movimiento es un leve "hundido" al pulsar (sin desplazamiento vertical).
    '&:active': { transform: 'scale(0.98)' },
    // Estado deshabilitado: sin degradado ni sombra para que se lea como inactivo.
    '&.Mui-disabled': {
        background: '#e2e8f0',
        color: '#94a3b8',
        boxShadow: 'none'
    }
};

export default starActionStyles;
